module.exports = __webpack_public_path__ + "static/station-3a662f17c847dda719b77799dc859c5a.jpg";